import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { RequestMethodEnum } from '@mogenius/client-sdk/core-dto';
import { NotificationService } from '@mogenius/shared/services/notification.service';
import { AuthService } from '@mogenius/user/services/auth/auth.service';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { errorBanner, parsedErrorBody } from './request-error.message';

export function requestErrorInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): any {
  const authService = inject(AuthService);
  const router = inject(Router);
  const notificationService = inject(NotificationService);

  const hideErrorMessage =
    request.headers.get('hideErrorMessage') ||
    request.headers.get('hideerrormessage') ||
    request.headers.get('hide-error-message');

  return next(request).pipe(
    catchError((error) => {
      if (error.status !== 401 && hideErrorMessage !== 'true' && hideErrorMessage !== '1') {
        // Assigned back, not just read: the `description` checks below and every
        // downstream subscriber expect the parsed body.
        error.error = parsedErrorBody(error.error);
        if (!(
          error.error?.description === 'isDemoOrganization' && request.method.toUpperCase() === RequestMethodEnum.GET
        )) {
          if (error.error?.description === 'UnAuthorized') {
            authService
              .clearData()
              .pipe(switchMap(() => from(router.navigate(['/', 'user', 'login']))))
              .subscribe();
          } else {
            // Optional chaining is load-bearing: on a network failure, a CORS
            // rejection or an aborted request there is no body at all, and
            // reading error.error.error threw a TypeError inside catchError --
            // which replaced the real failure with a broken one and left the
            // user with no banner whatsoever.
            // The URL comes from the request, not the error: an HttpErrorResponse
            // for a network failure or a CORS rejection has no usable body, and
            // without the caller URL a "Server error" banner cannot be traced
            // back to a route or a service.
            const banner = errorBanner(error?.status, error?.error, { method: request.method, url: request.url });
            notificationService.error(banner.header, banner.content, banner.detail);
          }
        }
      }

      return throwError(() => error);
    })
  );
}
